import { render, staticRenderFns } from "./ModalCardsVideo.vue?vue&type=template&id=c87796ce&"
import script from "./ModalCardsVideo.vue?vue&type=script&lang=js&"
export * from "./ModalCardsVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports